// skeleton/app/src/components/ProviderProfile/ResponseComponents/QPCalcualtedSectionComponent.tsx

import { Fragment } from "react";
import { Card } from "primereact/card";
import { Question } from "../models";
import DisputeQuestionAdditionalInfo from "../../Common/DisputeQuestionAdditionalInfo/DisputeQuestionAdditionalInfo";
import SafeHtml from "../../Common/SafeHtml";

export default function QPCalculatedSection({
    calculatedQuestions,
    isActiveDisputeReview,
    questionText
}: {
    calculatedQuestions: Question[];
    isActiveDisputeReview: boolean;
    questionText: string;
}) {
    return (
        <>
            {calculatedQuestions.map((question) => (
                <div
                    key={question.questionId}
                    style={{ marginBottom: "1rem" }}
                >
                    <Card>
                        <div
                            className="grid"
                            style={{
                                overflowX: "auto",
                                maxWidth: "100%"
                            }}
                        >
                            {question.responseData?.map((response, index) =>
                                response?.fieldName ? (
                                    <Fragment
                                        key={`${question.questionId}-${response.fieldName}-${index}`}
                                    >
                                        {questionText !== response.fieldName && (
                                            <div className="col-6">
                                                <span className="p-bold">
                                                    <SafeHtml html={response.fieldName} />
                                                </span>
                                            </div>
                                        )}

                                        <div className="col-6">
                                            <span>{response.fieldValue}</span>
                                        </div>
                                    </Fragment>
                                ) : null
                            )}
                        </div>
                    </Card>

                    {isActiveDisputeReview &&
                        (
                            question?.comment?.trim() ||
                            (
                                Array.isArray(question.attachments) &&
                                question.attachments.length > 0
                            )
                        ) && (
                            <DisputeQuestionAdditionalInfo
                                question={question}
                            />
                        )}
                </div>
            ))}
        </>
    );
}